import { useCallback, useEffect, useState } from 'react';

/**
 * Bočný panel zúžený na ikony (desktop). Pamätá sa na zariadení — kto si ho
 * raz zúžil, lebo pracuje na malom notebooku, nechce ho rozbaľovať po každom
 * spustení.
 *
 * Úložisko môže hodiť výnimku (súkromné okno v Safari, zakázané cookies).
 * Vtedy sa voľba nepamätá, ale prepínač musí fungovať ďalej.
 */
export const SIDEBAR_RAIL_KEY = 'whoworks:sidebar';

const readRail = (): boolean => {
  try {
    return localStorage.getItem(SIDEBAR_RAIL_KEY) === 'rail';
  } catch {
    return false;
  }
};

export const useSidebarRail = (): { rail: boolean; toggleRail: () => void; setRail: (rail: boolean) => void } => {
  const [rail, setRail] = useState(readRail);

  useEffect(() => {
    try {
      if (rail) {
        localStorage.setItem(SIDEBAR_RAIL_KEY, 'rail');
      } else {
        localStorage.removeItem(SIDEBAR_RAIL_KEY);
      }
    } catch {
      // Bez úložiska platí voľba do zatvorenia okna.
    }
  }, [rail]);

  const toggleRail = useCallback(() => setRail((current) => !current), []);
  return { rail, toggleRail, setRail };
};
